export const FORM_KEY_RESTOCK = 'restock'
export const FORM_KEY_SEND_NOTIFICATION = 'sendNotification'
export const FORM_KEY_SELECTED_REASON = 'selectedReason'
export const FORM_KEY_TYPE = 'type'
export const FORM_KEY_SUGGESTED_REFUND_TRANSACTIONS =
  'suggestedRefundTransactions'
export const FORM_KEY_VOIDABLE_TRANSACTIONS = 'voidableTransactions'
export const FORM_KEY_MAXIMUM_REFUNDABLE_SET = 'maximumRefundableSet'
